import {numUtil} from '@/helper/num';

export function formatDisplayValueStr(amountRq: number | string, precision: number = 4, keepEnd0: boolean = false): string {
  if (!amountRq) {
    return '--';
  }
  const value = numUtil.floor(amountRq, precision, 0);
  if (keepEnd0) {
    return numUtil.delimit(value);
  }
  return numUtil.delimit(numUtil.trimEnd0(value));
}

export function formatDisplayScaleValueStr(amountEv: number | string, scale: number = 8, precision: number = 4, keepEnd0: boolean = false): string {
  if (!amountEv && amountEv !== 0) {
    return '--';
  }
  const amountRq = numUtil.floor(amountEv, precision, scale);
  return formatDisplayValueStr(amountRq, precision, keepEnd0);
}

export function formatDisplayPercentage(rate: number | string, precision: number = 4): string {
  if (!rate && rate !== 0) {
    return '--%';
  }
  return numUtil.floor(rate, precision, -2) + '%';
}

export function genWeb3OptimisticNetworkAddressHref(address) {
  return address ? 'https://optimistic.etherscan.io/address/' + address : '';
}

export function genWeb3OptimisticNetworkTxIDHref(txID) {
  return txID ? 'https://optimistic.etherscan.io/tx/' + txID : '';
}

export function genWeb3EthNetworkTokenHref(tokenAdd) {
  return tokenAdd ? 'https://etherscan.io/token/' + tokenAdd : '';
}

export function genShortWalletAddress(address) {
  return address ? address.substring(0, 6) + '...' + address.substring(address.length - 4) : '';
}

export function genShortTxIDAddress(txID) {
  return txID ? txID.substring(0, 6) + '...' + txID.substring(txID.length - 4) : '';
}
